import React from 'react'
import { CartItem } from 'lib/core/data/quote/cart/types'
import { GiftMessageFormValues } from 'lib/core/hooks/useGiftMessageForm'
import { GiftMessageForm, onChangeCallback, OnSubmitCallback } from '../GiftMessageForm'
import { Container, ProductName, Image, ProductData } from './styled'

interface Props {
  item: CartItem
  onChange?: onChangeCallback
  onSubmit: OnSubmitCallback
  initialValues?: Partial<GiftMessageFormValues>
}

export const IndividualItem = ({ item, onChange, onSubmit, initialValues }: Props) => {
  const { image, name } = item.product

  return (
    <Container>
      <ProductData>
        <Image>
          <div
            style={{
              backgroundImage: `url(${image?.thumbnail.url})`
            }}
          />
        </Image>
        <ProductName>{name}</ProductName>
      </ProductData>
      <GiftMessageForm onChange={onChange} onSubmit={onSubmit} initialValues={initialValues} />
    </Container>
  )
}
